define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var config = require('config');
    var BaseModel = require('common/base.model');
    var recentlyPlayedGamesStore = require('stores/recently-played-games/recently-played-games.store.instance');
    var favoritesStore = require('stores/favorites/favorites.store.instance');

    module.exports = BaseModel.extend({

        defaults: {
            maxGamesLengthAllowed: config.get('maxGamesLengthAllowed') || 26,
            maxGamesFavoritesLengthAllowed: config.get('maxGamesFavoritesLengthAllowed') || 14
        },

        getRecentlyPlayedGames: function() {
            return recentlyPlayedGamesStore.fetch()
                .done(this.getRecentGamesWithConfiguration.bind(this));
        },

        getFavoriteGames: function() {
            favoritesStore.fetch()
                .done(this.getFavoriteGamesWithConfiguration.bind(this));
        },

        getRecentGamesWithConfiguration: function() {
            var recentlyPlayedGames = _.pluck(recentlyPlayedGamesStore.state, 'code');
            var recentGames = this.filterGames(recentlyPlayedGames);

            this.set('recentGames', recentGames);
        },

        filterGames: function(gameCodeList) {
            var gamesFromConfiguration = _.toArray(config.get('gamesConfiguration'));
            var filteredGames = [];
            _.each(gameCodeList, function(gameCode) {
                var gamesConfig = _.find(gamesFromConfiguration, {gameCode: gameCode});
                !_.isUndefined(gamesConfig) && filteredGames.push(gamesConfig);
            });

            return filteredGames.slice(0, this.defaults.maxGamesLengthAllowed);
        },

        getFavoriteGamesWithConfiguration: function() {
            var favoriteGamesCodes = _.pluck(favoritesStore.state, 'favoriteID');
            var games = this.filterGames(favoriteGamesCodes).reverse();

            this.set('favoriteGames', games);
        }
    });
});
